module.exports = __webpack_public_path__ + "static/media/invo_hero.9740fa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/invo_hero.png
// module id = 234
// module chunks = 0